import { defineStore } from 'ui.vue3.pinia';

export const useCoursesStore = defineStore("coursesnoauth", {
    state: () => ({
        list: [],              // текущий список курсов с фильтрами
        total: 0,              // всего курсов по фильтру
        filters: {},           // текущие фильтры (на будущее сделал может пригодиться фильтры)
        page: 1,               // текущая страница (на будущее для пагинации, пока у нас нет пагинации)
        perPage: 6             // курсов на странице
    }),

    getters: {
        count: (state) => state.list.length,
        getById: (state) => (id) => state.list.find(course => course.ID === id),
        totalPages: (state) => Math.ceil(state.total / state.perPage)
    },

    actions: {
        setCourses(coursesArray) {
            this.list = coursesArray || [];
        },

        addCourse(course) {
            this.list.push(course);
        },

        removeCourseById(courseId) {
            this.list = this.list.filter(course => course.ID !== courseId);
        },

        clear() {
            this.list = [];
            this.total = 0;
            this.page = 1;
        },

        setFilters(newFilters) {
            this.filters = newFilters;
            this.page = 1;
            this.fetchCourses();
        },

        setPage(newPage) {
            this.page = newPage;
            this.fetchCourses();
        },

        async fetchCourses() {
            try {
                const response = await BX.ajax.runComponentAction("gk:courses.catalog", "getCourses", {
                    mode: 'class',
                    data: {
                        page: this.page,
                        perPage: this.perPage,
                        filters: this.filters
                    }
                });

                this.list = response.data || [];
                this.total = response.data.total || 0;
            } catch (error) {
                console.error("Ошибка загрузки курсов:", error);
            }
        }
    }
});